// eslint-disable-next-line no-restricted-imports
import type { ExperimentalMutations } from '../__types__/ExperimentalMutations';
import { fetchJSON } from '../fetchJSON';
import { MediaType } from '../MediaType';
import { safeJSONParse } from '../safeJSONParse';

import { getEditDraftPageUrl } from './sharedTemplateBlueprintReqFns';

export const experimentalPublishPageByTemplate: ExperimentalMutations['experimentalPublishPageByTemplate'] =
	async (
		_,
		{ spaceKey, contentId, blueprint, context, title, attemptSpaUrlResponse = false },
		{ network },
	) => {
		const blueprintSpec = safeJSONParse(blueprint);
		const contextValue = context && safeJSONParse(context);

		const commonContentProperties: any = {
			type: 'page',
			status: 'draft',
			space: {
				key: spaceKey,
			},
			title,
		};

		if (contentId && contentId !== 'no-parent-page') {
			commonContentProperties.ancestors = [{ id: contentId }];
		}

		const json = await fetchJSON(
			network,
			`/wiki/rest/api/template/page/${blueprintSpec.templateId}/instance${
				attemptSpaUrlResponse ? '?expand=metadata.properties.editor,space' : ''
			}`,
			{
				method: 'POST',
				headers: {
					'Content-Type': MediaType.JSON,
				},
				body: JSON.stringify({
					content: {
						...commonContentProperties,
					},
					contentBlueprintSpec: {
						contentTemplateId: blueprintSpec.templateId,
						context: contextValue || {},
					},
				}),
			},
		);

		const editui = await getEditDraftPageUrl(json, attemptSpaUrlResponse);

		if (!editui) {
			throw new Error('Missing content draft url');
		}

		return {
			links: {
				draftUrl: editui,
			},
		};
	};
